import { render, staticRenderFns } from "./LeadTagSidebar.vue?vue&type=template&id=2b5c9b04"
import script from "./LeadTagSidebar.vue?vue&type=script&lang=js"
export * from "./LeadTagSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports